<template>
    <div className="News Wrapper h-100" style="height: 100%;">
         <NewsTemplate 
          :newsID="id"
          :src="src"
          :width="width"
          :height="height"
         />
     </div>
   </template>
   
   <script>
    import NewsTemplate from '../NewsTemplate.vue';
       export default {
           name:'NewsApp',
           components:{
                NewsTemplate
           },
           props: {
            id:String,
             width: Number,
             height:Number,
             src:String
           },
       }
   </script>
<style scoped>
.News.Wrapper{
    height: 100%;
  }


  </style>

